import * as React from 'react';
import * as style from './Results.css';
import { Preloader } from '@cian/preloader-component';

import { EGetFavoriteEntitiesStatus, IResultsState } from '../../types/results';
import { ResultsEmptyContainer } from '../../containers/ResultsEmpty';
import { FavoriteEntityContainer } from '../../containers/FavoriteEntity';
import { PaginationContainer } from '../../containers/Pagination';

export interface IResultsProps {
  results: IResultsState;
  foldersList: React.ReactNode;
  foldersHeader: React.ReactNode;
  topBar: React.ReactNode;
}

export class Results extends React.Component<IResultsProps, {}> {
  public render() {
    const {
      foldersList,
      foldersHeader,
      topBar,
      results: { favoriteEntities, editingNotes, status },
    } = this.props;

    return (
      <div className={style['wrapper']}>
        <div className={style['container']}>
          {foldersList && <div className={style['folders']}>{foldersList}</div>}
          <div className={style['content']}>
            {foldersHeader && <div className={style['header']}>{foldersHeader}</div>}
            {topBar}
            {favoriteEntities.length === 0 && <ResultsEmptyContainer />}
            {favoriteEntities.length > 0 && (
              <div>
                {favoriteEntities.map(favoriteEntity => {
                  const { entityId } = favoriteEntity;

                  return (
                    <FavoriteEntityContainer
                      key={`favoriteEntity_${entityId}`}
                      favoriteEntity={favoriteEntity}
                      isEditComment={editingNotes.hasOwnProperty(entityId)}
                      isFetchingComment={editingNotes[entityId] && editingNotes[entityId].isFetching}
                    />
                  );
                })}
              </div>
            )}
            <PaginationContainer />
            {status === EGetFavoriteEntitiesStatus.Loading && (
              <div className={style['preloader']}>
                <Preloader size={64} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
